import React from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import { connect } from 'react-redux';

import { H, Caption, Tiny } from 'deltoid/core/Blocks/Typography';
import { Container, Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import Form from 'deltoid/core/Form';

import { dialogActions, dialogSelectors, toastActions, uiActions } from '@store/ducks';


const Confirmation = ({
  dialogProps,
  isMobile,
  closeDialog,
  showToast,
  loadUI,
}) => {
  const { bankName, branchName, bankAccountNumber, holderName } = dialogProps;

  const handleOnConnect = () => {
    closeDialog();
    showToast({
      variant: 'success',
      title: 'Success!!',
      content: `
        Your account has been activated, please wait 
        while we load your payment tools
      `,
    });
    loadUI();
  }
  return (
    <div className='p-3' data-testid='bank-details-confirmation'>
      <H level={5} variant='bold' className='text-center pb-1'>{bankName}</H>
      <Caption variant='light' className='text-center pb-2'>{branchName}</Caption>
      <div className='pb-4'>
        <Row className='bank-row pb-1 m-auto'>
          <Col md={5}><Caption>AC Number:</Caption></Col>
          <Col md={7}>
            <Caption className={`co-text-grey-90 ${isMobile ? 'pb-2' : 'text-right'}`}>
              {bankAccountNumber}
            </Caption>
          </Col>
        </Row>
        <Row className='bank-row m-auto'>
          <Col md={5}><Caption>Acount Name:</Caption></Col>
          <Col md={7}>
            <Caption className={`co-text-grey-90 ${isMobile ? 'pb-2' : 'text-right'}`}>
              {holderName}
            </Caption>
          </Col>
        </Row>
      </div>
      <Row className='m-auto'>
        <Form.Button className='m-auto' onClick={handleOnConnect}>Confirm & Connect Bank</Form.Button>
      </Row>
      <div className="center-wrap-text">
        <Form.Button variant='underlined' onClick={closeDialog}>Wrong Account? Re-enter Bank Details</Form.Button>
      </div>
      <Tiny variant='light' className='text-center co-text-muted d-block'>
        We will compare the name on your PAN with the name on this bank account as 
        per RBI regulation.
      </Tiny>
    </div>
  )
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 576,
});

const ResponsiveConfirmation = withSizes(mapSizesToProps)(Confirmation);

const mapStateToProps = (state) => ({
  dialogProps: dialogSelectors.getProps(state),
})

const mapDispatchToProps = dispatch => ({
  closeDialog: () => dispatch(dialogActions.close()),
  showToast: (props) => dispatch(toastActions.show(props)),
  loadUI: () => dispatch(uiActions.loadUI({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveConfirmation);
